module.exports = __webpack_public_path__ + "static/anne-17969d548f25d0f335b810f43d0f1adc.jpg";